const BANDWIDTH_ADDRESS_ERROR_MARKERS = [
  'The provided street address could not be verified. Please submit a valid street address',
  'The verifiable address closest to the submitted access is included below. Please use that street address or another valid street address in your next request',
  'The provided street address could not be verified. Please submit a valid street address from telcosetup',
  'Address failed geo-validation',
  'geo-validation',
  '13231',
  '12112',
  '12113'
]

export function isBandwidthAddressError(message) {
  if (!message) return false
  const text = message.toString()
  return BANDWIDTH_ADDRESS_ERROR_MARKERS.some(marker =>
    text.toLowerCase().includes(marker.toLowerCase())
  )
}
